import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWarningSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconWarningSign"><Path d="M2.75 20.25L6.19407 6.0432C6.52028 4.69758 7.72503 3.75 9.10962 3.75H14.0715M14.0715 3.75H14.8904C16.275 3.75 17.4797 4.69758 17.8059 6.0432L21.25 20.25M14.0715 3.75C15.6906 3.75 16.8826 5.26551 16.5012 6.839L14.0985 16.75M13.25 20.25L14.0985 16.75M14.0985 16.75H4M14.0985 16.75H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconWarningSign;
